<template lang="pug">
  .full-image
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    //- 'background-image': `url(${image.loading})`
    figure.image(
      :style="{ 'height': `${height}px` }"
      :class="{ loaded }"
    )
      img(
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
import { mapGetters } from 'vuex';
import PreviewImage from './PreviewImage';
export default {
    name: 'FullImage',
    extends: PreviewImage,
    computed: {
        image() {
            let image = this.media.image;
            const source = image.source;

            let root = '';
            const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            return {
                src: `${base}${image.id}/${source.name}?fit&w=${this.width}&h=${this.height}${format}`,
                error: `${base}${image.id}/${source.name}?fit&w=${this.width}&preview=greyscale`,
                loading: `${base}${image.id}/${source.name}?fit&w=${this.width}&preview=blur`
            };
        },
        ...mapGetters({
            webpSupport: 'webpSupport'
        })
    }
};
</script>

<style lang="sass" scoped>
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
.image
  @apply bg-gray-200 flex justify-center items-center
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  width: 100%
  max-height: 80vh
  margin-bottom: 1rem
  // &.loaded
  //   height: auto !important
  img
    opacity: 0
    max-height: 100%
    width: auto
    transition: opacity .3s ease
    padding: 1rem
    background: #fff
    &.loaded
      opacity: 1
</style>
